import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import AzButton from '~/components/_next/atoms/AzButton.vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
import { useAuthenticatedAction } from '~/composables/useAuthenticatedAction';
import { useRecipesWishlists } from '~/composables/useRecipesWishlists';
import { useUser } from '~/composables/_next/useUser';
export default /*#__PURE__*/_defineComponent({
  __name: 'RecipesWishlistButton',
  props: {
    recipe: null,
    recipeId: null,
    recipeName: null
  },
  setup: function setup(__props) {
    var props = __props;
    var _useUser = useUser(),
      isAuthenticated = _useUser.isAuthenticated;
    var _useNuxt2App = useNuxt2App(),
      $flag = _useNuxt2App.$flag;
    var _useAuthenticatedActi = useAuthenticatedAction(),
      doActionOrLogin = _useAuthenticatedActi.doActionOrLogin,
      navigateToOrLogin = _useAuthenticatedActi.navigateToOrLogin;
    var _useUiState = useUiState(),
      toggleAddRecipeToWishlistSidebar = _useUiState.toggleAddRecipeToWishlistSidebar;
    var _useRecipesWishlists = useRecipesWishlists(),
      isInRecipesWishlists = _useRecipesWishlists.isInRecipesWishlists,
      removeRecipeFromWishlist = _useRecipesWishlists.removeRecipeFromWishlist;
    var route = useRoute();
    var isFavorite = computed(function () {
      return isInRecipesWishlists(props.recipeId);
    });
    function toggleRecipeFromWishlists() {
      if (isAuthenticated.value) {
        isFavorite.value ? removeFromWishlist() : toggleSidebar();
      } else {
        navigateToOrLogin({
          nextRoutePath: route.path,
          previousRoutePath: route.path
        });
      }
    }
    function removeFromWishlist() {
      removeRecipeFromWishlist(props.recipeId);
    }
    function toggleSidebar() {
      toggleAddRecipeToWishlistSidebar({
        contentfulId: props.recipeId,
        image: recipeImage.value,
        name: props.recipe.title
      });
    }
    var recipeImage = computed(function () {
      var _ref, _props$recipe$coverIm, _props$recipe, _props$recipe2, _props$recipe2$carous, _props$recipe2$carous2;
      return (_ref = (_props$recipe$coverIm = (_props$recipe = props.recipe) === null || _props$recipe === void 0 ? void 0 : _props$recipe.coverImageUrl) !== null && _props$recipe$coverIm !== void 0 ? _props$recipe$coverIm : (_props$recipe2 = props.recipe) === null || _props$recipe2 === void 0 ? void 0 : (_props$recipe2$carous = _props$recipe2.carousel) === null || _props$recipe2$carous === void 0 ? void 0 : (_props$recipe2$carous2 = _props$recipe2$carous.map(function (img) {
        var _img$fields, _img$fields$file;
        return (_img$fields = img.fields) === null || _img$fields === void 0 ? void 0 : (_img$fields$file = _img$fields.file) === null || _img$fields$file === void 0 ? void 0 : _img$fields$file.url;
      })) === null || _props$recipe2$carous2 === void 0 ? void 0 : _props$recipe2$carous2[0]) !== null && _ref !== void 0 ? _ref : '';
    });
    return {
      __sfc: true,
      props: props,
      isAuthenticated: isAuthenticated,
      $flag: $flag,
      doActionOrLogin: doActionOrLogin,
      navigateToOrLogin: navigateToOrLogin,
      toggleAddRecipeToWishlistSidebar: toggleAddRecipeToWishlistSidebar,
      isInRecipesWishlists: isInRecipesWishlists,
      removeRecipeFromWishlist: removeRecipeFromWishlist,
      route: route,
      isFavorite: isFavorite,
      toggleRecipeFromWishlists: toggleRecipeFromWishlists,
      removeFromWishlist: removeFromWishlist,
      toggleSidebar: toggleSidebar,
      recipeImage: recipeImage,
      AzButton: AzButton,
      AzIcon: AzIcon
    };
  }
});